<template>
  <div id="article-chart">
    <div class="vx-row match-height">
      <div class="vx-col lg:w-1/2 w-full">
        <div class="vx-card p-4">
          <vue-apex-charts ref="chartArticleIn7Day" type="area" height="440" :options="dataArticleIn7Day.chartOptions"
                           :series="dataArticleIn7Day.series"></vue-apex-charts>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 w-full lg:mt-0 mt-8">
        <div class="vx-card p-4">
          <vs-table :data="dataTitleNoDataTable">
            <template slot="header">
              <h3>
                Bảng thống kê đầu báo không có bài báo trong ngày hôm nay
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                STT
              </vs-th>
              <vs-th>
                Domain
              </vs-th>
              <vs-th>
                Số bài báo
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="ind" v-for="(item, ind) in data">
                <vs-td>
                  {{ item.stt }}
                </vs-td>

                <vs-td>
                  {{ item.domain }}
                </vs-td>

                <vs-td>
                  {{ item.data }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination class="mt-6" :total="totalPagesOneDay" v-model="currentPageOneDay" @change="loadPageOneDay" max="6"></vs-pagination>
        </div>
      </div>
    </div>
    <div class="vx-row match-height">
      <div class="vx-col lg:w-1/2 w-full mt-8">
        <div class="vx-card p-4">
          <vue-apex-charts ref="chartYesterday" type="bar" height="440" :options="dataChartYesterday.chartOptions"
                           :series="dataChartYesterday.series"></vue-apex-charts>
          <vs-pagination class="flex items-end" :total="totalPagesYesterday" v-model="currentYesterday"
                         @change="loadPageYesterday" max="6"></vs-pagination>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 w-full mt-8">
        <div class="vx-card p-4">
          <vs-table :data="dataTableCompare">
            <template slot="header">
              <h3>
                Bảng so sánh dữ liệu 3 ngày gần nhất
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                STT
              </vs-th>
              <vs-th>
                Domain
              </vs-th>
              <vs-th>
                {{beforeYesterDay}}
              </vs-th>
              <vs-th>
                {{yesterDay}}
              </vs-th>
              <vs-th>
                {{today}}
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="ind" v-for="(item, ind) in data">
                <vs-td>
                  {{ item.stt }}
                </vs-td>

                <vs-td>
                  {{ item.domain }}
                </vs-td>

                <vs-td>
                  {{ item.beforeYesterday }}
                </vs-td>

                <vs-td>
                  {{ item.yesterday }}
                </vs-td>

                <vs-td>
                  {{ item.today }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination class="mt-6" :total="totalPagesTableCompare" v-model="currentPageTableCompare"
                         @change="loadPageTableCompare" max="6"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import moment from "moment";

export default {
  name: "ArticleChart",

  components: {
    VueApexCharts,
  },

  data() {
    return {
      dateOptions: [],
      dataArticleIn7Day: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            type: 'area',
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          xaxis: {
            categories: []
          },
          title: {
            text: 'Biểu đồ thống kê bài báo',
            align: 'left',
            style: {
              fontSize: '20px',
              fontFamily: 'Roboto", Helvetica, sans-serif'
            }
          },
          subtitle: {
            text: 'Trong 7 ngày gần nhất',
            align: 'left',
            style: {
              fontFamily: 'Roboto", Helvetica, sans-serif'
            }
          },
        }
      },
      series: null,
      listDomain: [],
      dataOneDay: [],
      dataTitleNoData: [],
      dataTitleNoDataTable: [],
      currentPageOneDay: 1,
      totalPagesOneDay: 0,
      currentYesterday: 1,
      totalPagesYesterday: 0,
      dataArticleYesterday: [],
      dataChartYesterday: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 440,
            stacked: true
          },
          colors: ['#008FFB', '#FF4560'],
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '80%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 1,
            colors: ["#fff"]
          },

          grid: {
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          yaxis: {},
          tooltip: {
            shared: false,
            y: {
              formatter: function (val) {
                return Math.abs(val)
              }
            }
          },
          title: {
            text: 'Biểu đồ so sánh số bài báo theo đầu báo',
            align: 'left',
            style: {
              fontSize: '20px',
              fontFamily: 'Roboto", Helvetica, sans-serif'
            }
          },
          subtitle: {
            text: 'Trong ngày hôm qua - hôm nay',
            align: 'left',
            style: {
              fontFamily: 'Roboto", Helvetica, sans-serif'
            }
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Số bài báo',
              style: {
                fontFamily: 'Roboto", Helvetica, sans-serif'
              }
            },
            labels: {
              formatter: function (val) {
                return Math.abs(Math.round(val))
              }
            }
          },
        },
      },
      dataArticleBeforeYesterday: [],
      currentPageTableCompare: 1,
      totalPagesTableCompare: 0,
      dataTableCompare: [],
      beforeYesterDay: moment(new Date(new Date().setDate(new Date().getDate() - 2))).format('DD/MM/YYYY'),
      yesterDay: moment(new Date(new Date().setDate(new Date().getDate() - 1))).format('DD/MM/YYYY'),
      today: moment(new Date()).format('DD/MM/YYYY'),
    }
  },

  async created() {
    this.getDataDate();
    await this.getdataArticleIn7Day();
    await this.loadDomain();
    await this.getDataArticleOneDay();
    await this.getDataArticleYesterday();
    await this.getDataArticleBeforeYesterday();
  },

  methods: {
    getDataDate() {
      this.dateOptions = [
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 5)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 5)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 4)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 4)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 3)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 3)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 2)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 2)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999)).toISOString(),
        },
        {
          startDate: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
          endDate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
        },
      ]
    },

    async getdataArticleIn7Day() {
      let payload = {
        pageNumber: 0,
        pageSize: 1,
      }
      this.series = {
        name: 'Tổng số bài báo',
        data: []
      };
      let categories = [];
      this.dataArticleIn7Day.series = [];
      this.$vs.loading();

      for (const el of this.dateOptions) {
        payload['startDate'] = el.startDate;
        payload['endDate'] = el.endDate;
        categories.push(moment(el.startDate).format('DD/MM/YYYY'));

        await this.getArticle(payload);
      }
      this.$vs.loading.close();
      this.dataArticleIn7Day.series.push(this.series)
      this.$refs.chartArticleIn7Day.updateOptions({
        xaxis: {
          categories: categories
        }
      })
    },

    getArticle(payload) {
      return new Promise((resolve, reject) => {
        this.$processor.post('/search/find-data-news-detail', payload).then(res => {
          if (res.data.totalElements) {
            this.series.data.push(res.data.totalElements);
          } else {
            this.series.data.push(0);
          }
          resolve(res)
        }).catch((err) => {
          reject(err)
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      })
    },

    loadDomain() {
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        this.$task.get('/newspaper/find-all').then((response) => {
          let dataDomains = response.data.map(el => {
            el.numberOrder = el.numberOrder ? el.numberOrder : 0;
            return el;
          });
          dataDomains.forEach(el => {
            let item = this.listDomain.find(x => x.domain === el.nameDomain);
            if (item) {
              if (el.numberOrder > item.numberOrder) {
                let result = {
                  domain: el.nameDomain,
                  numberOrder: el.numberOrder
                }
                this.listDomain.filter(x => x.domain !== el.nameDomain)
                this.listDomain.push(result);
              }
            } else {
              let result = {
                domain: el.nameDomain,
                numberOrder: el.numberOrder
              }
              this.listDomain.push(result);
            }
          })
          // this.listDomain = Array.from(new Set(response.data.map(item => item.nameDomain)));
          resolve(response)
          this.$vs.loading.close();
        }).catch((err) => {
          reject(err)
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      })
    },

    async getDataArticleOneDay() {
      this.$vs.loading();
      try {
        const response = await Promise.all(this.listDomain.map(async el => {
          let payload = {
            pageNumber: 0,
            pageSize: 1,
            startDate: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
            endDate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
            domains: [el.domain]
          }
          const res = await this.$processor.post('/search/find-data-news-detail', payload);
          return {
            domain: el.domain,
            data: res.data.totalElements,
            numberOrder: el.numberOrder
          }
        }))
        this.dataOneDay = response.sort((a, b) => {
          if (a.numberOrder === b.numberOrder) {
            return b.domain - a.domain
          }
          return b.numberOrder - a.numberOrder;
        });
        this.dataTitleNoData = this.dataOneDay.filter(el => el.data === 0);
        this.totalPagesOneDay = this.dataTitleNoData.length % 10 > 0 ? (Math.floor(this.dataTitleNoData.length / 10) + 1) : Math.floor(this.dataTitleNoData.length / 10);
        this.loadPageOneDay(1);

        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    },

    async getDataArticleYesterday() {
      this.$vs.loading();
      try {
        const response = await Promise.all(this.listDomain.map(async el => {
          let payload = {
            pageNumber: 0,
            pageSize: 1,
            startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)).toISOString(),
            endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999)).toISOString(),
            domains: [el.domain]
          }
          const res = await this.$processor.post('/search/find-data-news-detail', payload);
          return {
            domain: el.domain,
            data: res.data.totalElements,
            numberOrder: el.numberOrder
          }
        }))
        this.dataArticleYesterday = response.sort((a, b) => {
          if (a.numberOrder === b.numberOrder) {
            return b.domain - a.domain
          }
          return b.numberOrder - a.numberOrder;
        });
        this.totalPagesYesterday = this.dataArticleYesterday.length % 10 > 0 ? (Math.floor(this.dataArticleYesterday.length / 10) + 1) : Math.floor(this.dataArticleYesterday.length / 10);
        this.loadPageYesterday(1);

        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    },

    async getDataArticleBeforeYesterday() {
      this.$vs.loading();
      try {
        const response = await Promise.all(this.listDomain.map(async el => {
          let payload = {
            pageNumber: 0,
            pageSize: 1,
            startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 2)).setHours(0, 0, 0, 0)).toISOString(),
            endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 2)).setHours(23, 59, 59, 999)).toISOString(),
            domains: [el.domain]
          }
          const res = await this.$processor.post('/search/find-data-news-detail', payload);
          return {
            domain: el.domain,
            data: res.data.totalElements,
            numberOrder: el.numberOrder
          }
        }))
        this.dataArticleBeforeYesterday = response.sort((a, b) => {
          if (a.numberOrder === b.numberOrder) {
            return b.domain - a.domain
          }
          return b.numberOrder - a.numberOrder;
        });
        this.totalPagesTableCompare = this.dataArticleBeforeYesterday.length % 10 > 0 ? (Math.floor(this.dataArticleBeforeYesterday.length / 10) + 1) : Math.floor(this.dataArticleBeforeYesterday.length / 10);
        this.loadPageTableCompare(1);

        this.$vs.loading.close();
      } catch (err) {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    },

    loadPageOneDay: function (page) {
      let result = this.dataTitleNoData.slice((page - 1) * 10, page * 10);
      result.map(el => {
        el.stt = (page - 1) * 10 + result.indexOf(el) + 1;
        return el
      })
      this.dataTitleNoDataTable = result;
    },

    loadPageYesterday: function (page) {
      this.dataChartYesterday.series = [];
      let categories = this.dataArticleYesterday.map(el => el.domain).slice((page - 1) * 10, page * 10),
        series1 = this.dataOneDay.map(el => el.data).slice((page - 1) * 10, page * 10),
        series2 = this.dataArticleYesterday.map(el => -el.data).slice((page - 1) * 10, page * 10);
      let dataSeties1 = {
          name: 'Hôm nay',
          data: series1
        },
        dataSeties2 = {
          name: 'Hôm qua',
          data: series2
        };
      let max1 = Math.max(...series1),
        max2 = Math.min(...series2);
      this.dataChartYesterday.series.push(dataSeties1, dataSeties2);
      this.$refs.chartYesterday.updateOptions({
        xaxis: {
          categories: categories
        },
        yaxis: {
          min: max1 > -max2 ? (-max1) : (+max2),
          max: max1 > -max2 ? (+max1) : (-max2),
        }
      });
    },

    loadPageTableCompare: function (page) {
      this.dataTableCompare = [];
      let day = this.dataOneDay.slice((page - 1) * 10, page * 10),
        yesterday = this.dataArticleYesterday.slice((page - 1) * 10, page * 10),
        before = this.dataArticleBeforeYesterday.slice((page - 1) * 10, page * 10);
      day.forEach(el => {
        let yes = yesterday.find(x => x.domain === el.domain),
          bef = before.find(x => x.domain === el.domain);
        let data = {
          stt: (page - 1) * 10 + day.indexOf(el) + 1,
          domain: el.domain,
          beforeYesterday: bef && bef.data ? bef.data : 0,
          yesterday: yes && yes.data ? yes.data : 0,
          today: el.data ? el.data : 0
        };
        this.dataTableCompare.push(data);
      })
    },
  }
}
</script>

<style lang="scss">
#article-chart {
  .vs-table--tbody {
    z-index: 200!important;
  }
  }
</style>
